import React, { Fragment, useState } from 'react';
import s from './ControlMeasure.module.scss';
import { useSelector } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { WidgetVisibility } from '../../../utils/widgetManager';
import { getDateInDDMMYYYFormat } from '../../../utils/index';
import ascendingIcon from '../../../assets/arrow-up.png';
import descendingIcon from '../../../assets/arrow-down.png';
import SearchBar from '../../SearchBar/SearchBar';
import { getCurrentTimezone } from '../../../selectors/index';

const ControlMonitoringListTable = ({
  controlMonitorings,
  userProfileWidgets,
  deleteAllowed,
  asendingOrder,
  onSortOrder,
  IsEditControlMeasure,
  view,
  viewAllowed,
  onViewClick,
  onAddNewClick,
  removeControlMonitoring,
  intl
}) => {
  let sortIcon = asendingOrder ? ascendingIcon : descendingIcon;
  const currentTimezone = useSelector(state => getCurrentTimezone(state));

  const [searchFilter, setSearchFilter] = useState('');

  const searchHandler = value => {
    setSearchFilter(value);
  };

  let controlMonitoringsFiltered =
    (searchFilter && controlMonitorings.filter(item => item.MonitoredItem.toLowerCase().indexOf(searchFilter.toLowerCase()) >= 0)) ||
    controlMonitorings;

  return (
    <div>
      <div className={s.controlMeasureTypeContent}>
        <Row>
          <Col>
            <h4 className={s.subheading}>
              <FormattedMessage id="controlMonitoring.controlMonitoring" defaultMessage="Control Monitorings" />
              <span className={s.circle}>{controlMonitoringsFiltered.filter(item => !item.IsDeleted).length || 0}</span>
            </h4>
          </Col>
        </Row>
        <Row>
          <Col xs={6} lg={4}>
            <SearchBar
              searchHandler={searchHandler}
              clearSearchInVisible={false}
              initialText={searchFilter}
              placeHolderTextId="controlMonitoring.searchMonitoredItem"
            />
          </Col>
          <Col xs={6} lg={8}>
            {(!view && IsEditControlMeasure && (
              <Button
                className={s.addbutton}
                style={WidgetVisibility(userProfileWidgets, 'WQSP_CONTROL_MONITORINGS_ADDNEW')}
                onClick={onAddNewClick}
              >
                + <FormattedMessage id="common.addNew" defaultMessage="ADD NEW" />
              </Button>
            )) ||
              ''}
          </Col>
        </Row>
      </div>
      <div>
        <Table variant className={s.innerTable}>
          <thead>
            <tr>
              <th>
                <FormattedMessage id="controlMonitoring.unitComponentPosition" defaultMessage="Unit Component Position" />
              </th>
              <th>
                <FormattedMessage id="controlMonitoring.stakeholder" defaultMessage="Stakeholder" />
              </th>
              <th>
                <FormattedMessage id="controlMonitoring.monitoredItem" defaultMessage="Monitored Item" />
              </th>
              <th className={s.sortHeading}>
                <span onClick={onSortOrder}>
                  <FormattedMessage id="common.lastReviewDate" defaultMessage="Last Review Date" />
                  <img className={s.sortIcon} src={sortIcon} alt="icon" />{' '}
                </span>
              </th>
              {(deleteAllowed || viewAllowed) && <th></th>}
            </tr>
          </thead>
          <tbody>
            {controlMonitoringsFiltered.map(item => {
              return (
                !item.IsDeleted && (
                  <tr key={item.GuidIdentifier} data-unittest="EventItemList">
                    <td>{item.ModelComponentPositionName}</td>
                    <td>{item.PersonnelName}</td>
                    <td>{item.MonitoredItem || ''}</td>
                    <td>{getDateInDDMMYYYFormat(item.LastReviewDate, currentTimezone) || ''}</td>
                    {(viewAllowed || deleteAllowed) && (
                      <td className={s.btnCol}>
                        {viewAllowed && (
                          <Button
                            variant="outline-secondary"
                            className={s.removeButton}
                            href="#"
                            onClick={() => {
                              onViewClick(item.ControlMonitoringId);
                            }}
                            // disabled={disableMode}
                            data-unittest="deleteData"
                          >
                            <FormattedMessage id="common.view" defaultMessage="View" />
                          </Button>
                        )}

                        {deleteAllowed && (
                          <Button
                            variant="outline-secondary"
                            className={s.removeButton}
                            href="#"
                            onClick={() => {
                              removeControlMonitoring(item.ControlMonitoringId);
                            }}
                            // disabled={disableMode}
                            data-unittest="deleteData"
                            style={WidgetVisibility(userProfileWidgets, `WQSP_CONTROL_MONITORINGS_DELETE`)}
                          >
                            <FormattedMessage id="common.remove" defaultMessage="Remove" />
                          </Button>
                        )}
                      </td>
                    )}
                  </tr>
                )
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

ControlMonitoringListTable.defaultProps = {
  controlMonitorings: {},
  userProfileWidgets: [],
  updateAllowed: false
};

export default injectIntl(ControlMonitoringListTable);
